import React, { PureComponent } from "react";
import cx from "classnames";
//
import Icon from "./Icon";

export default class Checkbox extends PureComponent {
  _onChange = (ev) => this.props.onChange(ev.target.checked);

  render() {
    const { checked, disabled, label, className } = this.props;

    return (
      <div className={cx("checkbox", className, { disabled })}>
        <label>
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            value="1"
            onChange={this._onChange}
            className="checkbox__input"
          />
          <span className="checkbox__label">{label}</span>
        </label>
      </div>
    );
  }
}
